import { request } from '@blade/common';
import { useLocal } from '.';
let list = [];
for (let i = 0; i < 20; i++) {
    if (useLocal) {
        addVehicle({
            images: ['https://t12.baidu.com/it/u=2822331734,817922406&fm=58'],
            libIds: [1],
            plateNumber: 'WLP 9292',
            type: 'SUV',
            color: 'White',
            brand: 'BWM',
            plateNumberColor: 'Blue',
            plateNumberType: '普通小型车',
            ownerName: 'lrf',
            ownerId: 'lrf',
            remark: 'xxxxx',
            automobileLibs: [
                {
                    libId: 1,
                    name: 'Black list'
                }
            ],
            image: ''
        });
    }
}
export function updateVehicle(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/automobile/update/automobile/${data.automobileId}`,
            method: 'PUT',
            data,
        });
    }
    return new Promise((resolve) => {
        const result = list.find(p => p.automobileId === data.automobileId);
        if (result) {
            for (const key in result) {
                result[key] = data[key];
            }
        }
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function deleteAutomobileRelation(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/automobile/delete`,
            method: 'DELETE',
            data,
        });
    }
    return new Promise((resolve, reject) => {
        list = list.filter(a => a.relationId !== data.relationId);
        setTimeout(() => {
            resolve(null);
        }, 200);
    });
}
export function batchDeleteAutomobiles(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/automobile/batch/delete`,
            method: 'POST',
            data,
        });
    }
    return new Promise((resolve, reject) => {
        list = list.filter(a => !data.automobileIds.includes(a.automobileId));
        setTimeout(() => {
            resolve(null);
        }, 200);
    });
}
export function queryAutomobileDetail(automobileId) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/automobile/${automobileId}`,
            method: 'GET'
        });
    }
    return new Promise((resolve, reject) => {
        const result = list.find(a => a.automobileId === automobileId);
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function addVehicle(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/automobile/add`,
            method: 'POST',
            data
        });
    }
    return new Promise((resolve) => {
        const result = {
            ...data,
            automobileId: Math.random() * 100000000,
            relationId: Math.random() * 100000000,
            name: 'x',
            createBy: 'lrf',
            updateBy: 'lrf'
        };
        list.push(result);
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function queryVehiclePageList(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/automobile/page/query`,
            method: 'POST',
            data
        });
    }
    return new Promise((resolve) => {
        // 先过滤
        const tmp = list.filter(a => !data.keywords || a.ownerId.includes(data.keywords) || a.ownerName.includes(data.keywords) || a.plateNumber.includes(data.keywords));
        // 再分页
        const page = data.page ?? 1;
        const size = data.size ?? 10;
        const result = {
            page,
            size,
            total: tmp.length,
            totalPage: parseInt(tmp.length / size + '') + tmp.length % size > 0 ? 1 : 0,
            list: tmp.slice((page - 1) * size, page * size),
            empty: false
        };
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
/** 导出车辆 */
export function vehicleExport(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/automobile/export/autombile`,
            method: 'POST',
            data
        });
    }
}
// 车辆类型和车身颜色
export const automobileTypeOrColor = (data) => {
    return request.post(`/api/portrait-management/api/v1/automobile/filter/tree/query`, data);
};
